import { Action } from '@reduxjs/toolkit'
import { planRepository, planStore } from '@entities/plan'
import { of, filter, Observable, from, concat } from 'rxjs'
import { catchError, mergeMap } from 'rxjs/operators'
import { registerEpic } from '@shared/lib/redux'

const getPlanListEpic = (action$: Observable<Action>) =>
  action$.pipe(
    filter(planStore.actions.getPlanList.match),
    mergeMap((_action) =>
      from(planRepository.getList()).pipe(
        mergeMap((planListData) =>
          concat(of(planStore.actions.getPlanListSuccess(planListData)))
        ),
        catchError((error) =>
          of(planStore.actions.getPlanListFailure(error as string))
        )
      )
    )
  )

const getPaymentMethodsListEpic = (action$: Observable<Action>) =>
  action$.pipe(
    filter(planStore.actions.getPaymentMethodList.match),
    mergeMap((_action) =>
      from(planRepository.getMethodsList()).pipe(
        mergeMap((planListData) =>
          concat(
            of(planStore.actions.getPaymentMethodListSuccess(planListData))
          )
        ),
        catchError((error) =>
          of(planStore.actions.getPaymentMethodListFailure(error as string))
        )
      )
    )
  )

registerEpic(getPlanListEpic)
registerEpic(getPaymentMethodsListEpic)
